import * as React from 'react';

import type { PublicationClient } from '@/api/publication-client';
import { HttpPublicationClient } from '@/api/publication-client.http';

// =============================================================================
// publication-client-context.tsx — Injection du PublicationClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S18) : l'adaptateur HTTP RÉEL
// (HttpPublicationClient) — le câblage front↔back contre les surfaces gelées du stream C. Les tests de
// composant injectent le StubPublicationClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session admin). */
const defaultPublicationClient: PublicationClient = new HttpPublicationClient();

const PublicationClientContext = React.createContext<PublicationClient>(
  defaultPublicationClient,
);

export interface PublicationClientProviderProps {
  client?: PublicationClient | undefined;
  children: React.ReactNode;
}

export function PublicationClientProvider({
  client = defaultPublicationClient,
  children,
}: PublicationClientProviderProps): React.JSX.Element {
  return (
    <PublicationClientContext.Provider value={client}>
      {children}
    </PublicationClientContext.Provider>
  );
}

export function usePublicationClient(): PublicationClient {
  return React.useContext(PublicationClientContext);
}
